import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import { useUserContext } from 'src/common/providers/UserProvider';
import getClassNames from 'src/common/utils/getClassNames';
import Icon from '../IconDS22';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';
import LogoutButton from './LogoutButton';
import style from './Navigation.module.scss';

const LogoutNavItem: FC = () => {
  const [t] = useTranslation('navbar');
  const { logout } = useUserContext();

  return (
    <ComponentWrapper>
      <LogoutButton
        onClick={logout}
        className={getClassNames(style, 'link', 'button nestedMenu')}
      >
        <Icon
          id="logout"
          className={getClassNames(style, 'icon', 'logout')}
        />
        {t('logout')}
      </LogoutButton>
    </ComponentWrapper>
  );
};
export default LogoutNavItem;
